import React from "react";
import { Star, Quote } from "lucide-react";
import "../style/testimonials.css";

const testimonials = [
  {
    name: "Sarah Mitchell",
    role: "Homeowner",
    rating: 5,
    text: "Booked a 4m³ skip for our garage cleanout. Delivered same day and pickup was right on time. Couldn't be easier!",
  },
  {
    name: "David Chen",
    role: "Construction Manager",
    rating: 5,
    text: "We use Jerry's Bins for all our site projects now. Reliable delivery, fair pricing, and great communication every time.",
  },
  {
    name: "Priya Sharma",
    role: "Small Business Owner",
    rating: 5,
    text: "Affordable and hassle-free. Online booking took less than 5 minutes and the bin arrived exactly when promised.",
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials-section">
      <div className="testimonials-header">
        <h2>What Our Customers Say</h2>
        <div className="underline"></div>
      </div>

      <div className="testimonials-grid">
        {testimonials.map((t, index) => (
          <div className="testimonial-card" key={index}>
            <Quote className="quote-icon" />
            <div className="stars">
              {Array.from({ length: t.rating }).map((_, i) => (
                <Star key={i} className="star-icon" fill="#F5821F" />
              ))}
            </div>
            <p className="testimonial-text">{t.text}</p>
            <div className="testimonial-author">
              <div className="author-avatar">{t.name.charAt(0)}</div>
              <div className="author-info">
                <h4>{t.name}</h4>
                <span>{t.role}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;